import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {Tag} from 'primereact/tag'
import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useMemo,
    useRef,
} from 'react'
import TranslateUtils from '../../../i18n/TranslateUtils'
import {component} from '../../form/Constant'
import StyledTitle from '../../layout/StyledTitle'
import StyledDropdown from '../components/StyledDropdown'
import StyledInput from '../components/StyledInput'
import StyledInputMask from '../components/StyledInputMask'
import StyledAddressInformationUtils from './StyledAddressInformationUtils'
import StyledGeneralPractitionerUtils from './StyledGeneralPractitionerUtils'

const StyledDetailInformationSection = forwardRef(
    (
        {
            data = {},
            dataList = [],
            hideLockButton = false,
            hideRevertButton = false,
            onSubmit = () => {},
        },
        ref,
    ) => {
        useImperativeHandle(ref, () => ({
            onSuccess: handleOnSuccess,
        }))
        useSignals()

        //#region Translate
        const {translateCommons} = TranslateUtils()
        //#endregion

        //#region State
        const infoData = useMemo(() => {
            if (!data || !data?.id) {
                return {}
            }

            return data
        }, [data])

        const formData = useSignal({})

        const handleOnSuccess = () => {
            isLock.value = true
        }

        useEffect(() => {
            if (infoData && infoData?.id) {
                formData.value =
                    infoData && Object.keys(infoData)?.length > 0
                        ? {...infoData}
                        : {}
            }
        }, [infoData])

        const isChangedValue = useSignal(false)
        const isLock = useSignal(true)
        const codeConfigRef = useRef(null)
        //#endregion

        const handleOnSubmit = () => {
            // if (!isChangedValue.value) {
            //     return
            // }

            let toPostData
            let codeConfigData

            if (codeConfigRef.current && codeConfigRef.current.getValue) {
                codeConfigData = {
                    codeConfig: codeConfigRef.current.getValue(),
                }
            }

            if (codeConfigData) {
                toPostData = {
                    ...formData.value,
                    ...codeConfigData,
                }
            } else {
                toPostData = {
                    ...formData.value,
                }
            }

            if (onSubmit) {
                onSubmit(toPostData)
            }
        }

        const handleOnChange = (key, value) => {
            if (!isChangedValue.value) {
                isChangedValue.value = true
            }

            formData.value = {...formData.value, [key]: value}
        }

        const handleOnChangeCheckbox = (key, value) => {
            if (!isChangedValue.value) {
                isChangedValue.value = true
            }

            if (!value) {
                return
            }

            if (!formData.value) {
                formData.value = {
                    [key]: [value],
                }

                return
            }

            if (!formData.value[key] || !formData.value[key]?.length) {
                formData.value = {
                    ...formData.value,
                    [key]: [value],
                }
                return
            }

            if (!formData.value[key].includes(value)) {
                formData.value = {
                    ...formData.value,
                    [key]: [...formData.value[key], value],
                }
            } else {
                let filterList = formData.value[key]?.filter(
                    item => item !== value,
                )
                formData.value = {
                    ...formData.value,
                    [key]: [...filterList],
                }
            }
        }

        const handleAddressOnChange = value => {
            if (!isChangedValue.value) {
                isChangedValue.value = true
            }
            formData.value = {...formData.value, ...value}
        }

        const handleEditForm = () => {
            if (isChangedValue.value) {
                handleOnSubmit()
                isChangedValue.value = false
            }
            //  else {
            //     isLock.value = !isLock.value
            // }
            // if (!isLock.value) {
            //     handleOnSubmit()
            // }
            // isLock.value = !isLock.value
        }

        const handleOnUndo = () => {
            formData.value = {...data}
            isChangedValue.value = false
        }

        return (
            <div className="">
                {dataList?.length && (
                    <div className="">
                        {dataList.map((item, index) => (
                            <div
                                key={item?.key + '-' + index}
                                className="col-12 px-0">
                                <div className="flex justify-content-between align-items-center flex-wrap ">
                                    <StyledTitle
                                        title={translateCommons(item?.label)}
                                        icon={item.icon}
                                        description={item.description}
                                    />
                                    <div className="flex">
                                        {isChangedValue.value && (
                                            <Button
                                                label="Save changes"
                                                icon="pi pi-save"
                                                className="p-button-outlined mr-2 hover:text-blue-400 hover:bg-white hover:border-blue-200 border-none"
                                                onClick={handleEditForm}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div>
                                    {item.children?.map((children, index) => (
                                        <ul className="list-none m-0 p-0">
                                            <li
                                                key={children?.key + index}
                                                className={`flex align-items-center  ${
                                                    index % 2 === 0 &&
                                                    children?.component !==
                                                        component.address &&
                                                    children?.component !==
                                                        component.generalPractitioner
                                                        ? 'bg-gray-50'
                                                        : ''
                                                } ${
                                                    children?.component !==
                                                        component.address &&
                                                    children?.component !==
                                                        component.generalPractitioner
                                                        ? 'px-2'
                                                        : ''
                                                }`}>
                                                {children?.component !==
                                                    component.address &&
                                                    children?.component !==
                                                        component.generalPractitioner && (
                                                        <div className="w-full md:w-3">
                                                            <div
                                                                key={
                                                                    children?.key +
                                                                    index
                                                                }
                                                                className={`${
                                                                    children?.col
                                                                        ? children?.col
                                                                        : ''
                                                                }`}>
                                                                <div className="mb-2">
                                                                    {/* Component Header */}
                                                                    {children.component !==
                                                                        component.address &&
                                                                        children.component !==
                                                                            component.generalPractitioner &&
                                                                        !children?.hideHeader && (
                                                                            <div className="flex align-items-center justify-content-between">
                                                                                <div className="w-15rem md:w-20rem ">
                                                                                    <h6 className="text-600 font-bold mt-4 white-space-nowrap ">
                                                                                        {
                                                                                            children?.label
                                                                                        }
                                                                                    </h6>
                                                                                </div>

                                                                                <div>
                                                                                    {children?.required && (
                                                                                        <Tag
                                                                                            value={
                                                                                                'This field is required !'
                                                                                            }
                                                                                            severity="danger"
                                                                                            icon="pi pi-info-circle"></Tag>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                <div
                                                    className={`w-full ${
                                                        children?.component !==
                                                            component.address &&
                                                        children?.component !==
                                                            component.generalPractitioner
                                                            ? 'ml-6'
                                                            : ''
                                                    }`}>
                                                    {/* Children Component */}
                                                    {/* Input Text */}
                                                    {children?.component ===
                                                        component.inputText && (
                                                        <StyledInput
                                                            value={
                                                                (formData.value &&
                                                                    formData
                                                                        .value[
                                                                        children
                                                                            ?.key
                                                                    ]) ||
                                                                (infoData &&
                                                                    infoData[
                                                                        children
                                                                            ?.key
                                                                    ]) ||
                                                                children?.defaultValue ||
                                                                'Unknown'
                                                            }
                                                            className={`border-none focus:outline-none focus:shadow-none ${
                                                                index % 2 === 0
                                                                    ? 'bg-gray-50'
                                                                    : 'bg-white'
                                                            }`}
                                                            placeholder={
                                                                children?.placeholder
                                                            }
                                                            onChange={newValue => {
                                                                handleOnChange(
                                                                    children.key,
                                                                    newValue,
                                                                )
                                                            }}
                                                        />
                                                    )}

                                                    {/* Dropdown */}
                                                    {children?.component ===
                                                        component.dropdown && (
                                                        <StyledDropdown
                                                            value={
                                                                (formData.value &&
                                                                    formData
                                                                        .value[
                                                                        children
                                                                            ?.key
                                                                    ]) ||
                                                                (infoData &&
                                                                    infoData[
                                                                        children
                                                                            ?.key
                                                                    ]) ||
                                                                children?.defaultValue ||
                                                                null
                                                            }
                                                            options={
                                                                children?.options ||
                                                                []
                                                            }
                                                            className={`w-full border-none focus:outline-none focus:shadow-none ${
                                                                index % 2 === 0
                                                                    ? 'bg-gray-50'
                                                                    : 'bg-white'
                                                            }`}
                                                            onChange={newValue => {
                                                                handleOnChange(
                                                                    children.key,
                                                                    newValue,
                                                                )
                                                            }}
                                                            valueTemplate={
                                                                children?.key ===
                                                                'gender'
                                                                    ? selectedOption =>
                                                                          selectedOption ? (
                                                                              <Tag
                                                                                  value={
                                                                                      selectedOption.label
                                                                                  }
                                                                                  className="px-3 text-white text-sm font-bold rounded-full"
                                                                                  style={{
                                                                                      backgroundColor:
                                                                                          selectedOption.value ===
                                                                                          'male'
                                                                                              ? '#3B82F6'
                                                                                              : selectedOption.value ===
                                                                                                'female'
                                                                                              ? '#EC4899'
                                                                                              : '#6B7280',
                                                                                  }}
                                                                              />
                                                                          ) : (
                                                                              <span className="text-gray-400">
                                                                                  Select
                                                                                  gender
                                                                              </span>
                                                                          )
                                                                    : undefined
                                                            }
                                                        />
                                                    )}

                                                    {/* Input Mask */}
                                                    {children?.component ===
                                                        component.inputMask && (
                                                        <StyledInputMask
                                                            value={
                                                                (formData.value &&
                                                                    formData
                                                                        .value[
                                                                        children
                                                                            ?.key
                                                                    ]) ||
                                                                (infoData &&
                                                                    infoData[
                                                                        children
                                                                            ?.key
                                                                    ]) ||
                                                                children?.defaultValue ||
                                                                ''
                                                            }
                                                            placeholder={
                                                                children?.placeholder
                                                            }
                                                            className={`border-none focus:outline-none focus:shadow-none  ${
                                                                index % 2 === 0
                                                                    ? 'bg-gray-50'
                                                                    : ''
                                                            }`}
                                                            onChange={newValue => {
                                                                handleOnChange(
                                                                    children.key,
                                                                    newValue,
                                                                )
                                                            }}
                                                        />
                                                    )}
                                                    {/* Address */}
                                                    {children?.component ===
                                                        component.address && (
                                                        <StyledAddressInformationUtils
                                                            shouldTextBold={
                                                                true
                                                            }
                                                            data={
                                                                formData.value
                                                            }
                                                            onChange={newValue => {
                                                                handleAddressOnChange(
                                                                    newValue,
                                                                )
                                                            }}
                                                            // isLock={!!isLock.value}
                                                        />
                                                    )}
                                                    {/* General Practitioner */}
                                                    {children?.component ===
                                                        component.generalPractitioner && (
                                                        <StyledGeneralPractitionerUtils
                                                            shouldTextBold={
                                                                true
                                                            }
                                                            isLock={
                                                                isLock.value
                                                            }
                                                            data={
                                                                formData.value
                                                            }
                                                            className={
                                                                item.className
                                                                    ? item.className
                                                                    : ''
                                                            }
                                                            childrenClassName={
                                                                item.childrenClassName
                                                                    ? item.childrenClassName
                                                                    : ''
                                                            }
                                                            onChange={newValue => {
                                                                handleOnChange(
                                                                    'generalPractitioner',
                                                                    newValue,
                                                                )
                                                            }}
                                                            defaultValue={
                                                                item.initialValue
                                                                    ? item.initialValue
                                                                    : {}
                                                            }
                                                        />
                                                    )}
                                                    {/* Description */}
                                                    {children?.description &&
                                                        !children?.hideDescription &&
                                                        (typeof children?.description ===
                                                        'string' ? (
                                                            <p>
                                                                {
                                                                    children?.description
                                                                }
                                                            </p>
                                                        ) : (
                                                            children?.description
                                                        ))}
                                                </div>
                                            </li>
                                        </ul>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )
    },
)

export default StyledDetailInformationSection
